import classNames from 'classnames';
import styles from './Switch.module.scss';

interface SwitchProps {
  checked: boolean;
  optionOne?: string;
  optionTwo?: string;
  disabled?: boolean;
  toggleOnly?: boolean;
  onChange: (value: boolean) => void;
  theme?: 'primary' | 'secondary';
  customStyles?: string;
}
export const Switch = ({
  checked,
  onChange,
  optionOne,
  optionTwo,
  disabled,
  toggleOnly = false,
  theme = 'primary',
  customStyles,
}: SwitchProps) => (
  <div className={classNames(styles.switchContainer, 'my-8 mr-2', customStyles)}>
    {optionOne &&
      (toggleOnly ? (
        <span data-testid={`switch-label-${optionOne}`}>{optionOne}</span>
      ) : (
        <a
          href="#"
          data-testid={`switch-link-${optionOne}`}
          onClick={() => onChange(false)}
          className={classNames(!checked && 'text-igus-primary', 'no-underline cursor-pointer')}
        >
          {optionOne}
        </a>
      ))}
    <label className={classNames('mx-4 relative')}>
      <input
        disabled={disabled}
        checked={checked}
        type="checkbox"
        aria-label={optionTwo || optionOne}
        className={classNames('absolute mt-2 opacity-0 w-0 h-0', styles[theme])}
        onChange={() => onChange(!checked)}
        data-testid="switch-cmp"
      />
      <span
        data-testid="switch-slider"
        className={classNames(
          styles.slider,
          toggleOnly && !checked ? styles.onOffToggle : '',
          'absolute inset-0',
          'cursor-pointer',
          styles[theme]
        )}
      />
    </label>
    {optionTwo &&
      (toggleOnly ? (
        <span data-testid={`switch-label-${optionTwo}`}>{optionTwo}</span>
      ) : (
        <a
          data-testid={`switch-link-${optionTwo}`}
          onClick={() => onChange(true)}
          className={classNames(checked && 'text-igus-primary', 'cursor-pointer')}
        >
          {optionTwo}
        </a>
      ))}
  </div>
);
